import { ElementType } from 'react';

export type ResolvedIcon =
  | { type: 'icomoon'; value: string }
  | { type: 'svg'; value: string }
  | { type: 'material'; value: string }
  | { type: 'phosphor'; component: ElementType }
  | { type: 'eto'; component: ElementType };


export type IconResolver = (name: string) => ResolvedIcon;

export type IconLibrary = 'icomoon' | 'phosphor' | 'material' | 'custom';
export enum IconPack {
  default = 'default',
  thin = 'thin',
  eto = 'eto'
}

